import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs-compat';

@Component({
  selector: 'ngx-collections',
  template: `<ngx-one-column-layout>
               <router-outlet></router-outlet>
            </ngx-one-column-layout>`,
  styleUrls: ['./collections.component.scss']
})
export class CollectionsLayoutComponent {

}